import { getCookie, setCookie } from "~/common/utils/cookie";
import dayjs from "dayjs";

const CAD_FORMAT_COOKIE = "CAD_FORMAT";

export function getCadFormatCookie(): string {
  return getCookie(CAD_FORMAT_COOKIE)?.value ?? "";
}

export function setCadFormatCookie(format: string) {
  setCookie({ name: CAD_FORMAT_COOKIE, value: format, expireDate: dayjs().add(1, "w").toDate() }); // expires in 1 week from NOW
}
